module.exports = "<template> <tcw-backdrop hidden part=backdrop></tcw-backdrop> <div class=tyl-bottom-sheet part=root> <slot></slot> </div> </template> ";